import React from "react";
import { useSelector } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { selectUser } from "../auth/authSlice";
import authList from "./routeAuthData";
import authListIncomplete from "./routeAuthIncompleteData";

const AuthRoute: React.FC<{}> = () => {
  const user = useSelector(selectUser);
  return (
    <>
      {user?.profileCompleted ? (
        <RouterProvider
          future={{
            v7_startTransition: true,
          }}
          router={authList}
        ></RouterProvider>
      ) : (
        <RouterProvider
          future={{
            v7_startTransition: true,
          }}
          router={authListIncomplete}
        ></RouterProvider>
      )}
    </>
  );
};

export default AuthRoute;
